<template>
  <div class="dynamic_detail">
    <Fontnavbar title="动态详情" />
    <div class="goods_list" @click="goPage('/goods/detail?id=' + item_goods.id)" v-for="(item_goods, i_goods) in detailData.goods_list" :key="i_goods">
      <div class="left_img">
        <img :src="imgDomain + item_goods.goods_thumb_path" alt="" width="50" height="50">
      </div>
      <div class="right_info">
        <p>{{ item_goods.goods_name }}</p>
        <p>批发价：{{ item_goods.user_price }}</p>
      </div>
    </div>
    <!-- 动态详情 -->
    <div class="detail_cont">
      <div v-html="detailData.content"></div>
      <img :src="item" alt="" v-for="(item, index) in imgArr" :key="index" @click="show_img(index)">
    </div>
    <backTop />
  </div>
</template>

<script>
import { ImagePreview, Dialog } from "vant";
import backTop from "../../components/backTop.vue";
import Fontnavbar from "@/components/Navbar.vue";
import { getDynamicDetail } from "../../api.js";
import { post } from "../../request.js";
export default {
  components: {
    [ImagePreview.name]: ImagePreview,
    backTop,
    Fontnavbar
  },

  data() {
    return {
      imgDomain: process.env.VUE_APP_IMG_URL,
      detailData: [],
      imgArr:[],
      dynamic_id:''
    };
  },
  created() {
    // this.detailData = JSON.parse(this.$route.query.goods)
    // this.imgArr = this.detailData.gallary_array.map(item=>{
    //   return this.imgDomain + item
    // })
    // console.log(this.detailData, this.imgArr)

  var that=this
  that.dynamicId=this.$route.query.goods

    post(getDynamicDetail, { dynamic_id: that.dynamicId }).then((res) => {
      if (res.code == 200) {
       this.detailData=res.data
       this.imgArr = this.detailData.gallary_array.map(item=>{
      return this.imgDomain + item
    })
      } else{
          Dialog({message:res.msg})
      }
    });
  },
  mounted() {
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    //查看大图
    show_img(index) {
      ImagePreview({
        images: this.imgArr,
        startPosition: index,
        closeable: true,
      });
    },
    goPage(path) {
      this.$router.push({ path: path });
    },
  },
};
</script>

<style lang="less" scoped>
.dynamic_detail {
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  .goods_list {
    display: flex;
    align-items: center;
    margin: 12px;
    background-color: #f8f8f8;
    font-size: 14px;
    .left_img {
      margin: 0 12px;
    }
  }
  .detail_cont{
    padding: 12px;
    div{
      padding: 12px 0;
    }
    img{
      width: 100%;
    }
  }
}
</style>
